import React, { useState } from 'react';
import { message, Menu } from 'antd';
import {
  AppstoreOutlined,
  SafetyCertificateOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { Link, Outlet, useLocation } from 'react-router-dom';
import Modules from './modules';

const RolesPermission = () => {
  const location = useLocation();
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedTab, setSelectedTab] = useState('modules');

  const changeSelectedTab = (tab) => {
    const currentTab = selectedTab;
    if (tab !== currentTab) {
      setSelectedTab(tab);
    }
  }

  const menuItems = [
    {
      key: 'roles',
      icon: <TeamOutlined />,
      label: <Link onClick={() => changeSelectedTab('roles')} to="/settings/roles-permissions?tab=roles">Roles</Link>,
    },
    {
      key: 'permissions',
      icon: <SafetyCertificateOutlined />,
      label: <Link onClick={() => changeSelectedTab('permissions')} to="/settings/roles-permissions?tab=permissions">Permissions</Link>,
    },
    {
      key: 'modules',
      icon: <AppstoreOutlined />,
      label: <Link onClick={() => changeSelectedTab('modules')} to="/settings/roles-permissions?tab=modules">Modules</Link>,
    },
  ];

  return (
    <>
      {contextHolder}
      <div style={{ display: 'flex' }}>
        <Menu
          theme="light"
          mode="inline"
          defaultSelectedKeys={[selectedTab]}
          items={menuItems}
          style={{ width: '150px' }}
        />

        <div style={{ flex: 1, padding: 20 }}>
          {
            selectedTab === 'modules' && <Modules />
          }
        </div>
      </div>
    </>
  );
};

export default RolesPermission;
